import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Link, Typography } from "@mui/material";

import ExpandIcon from "./ExpandIcon";

interface BetaBannerProps {
  isExpanded: boolean;
  onToggle: () => void;
}

const BetaBanner = ({ isExpanded, onToggle }: BetaBannerProps) => (
  <Box
    onClick={onToggle}
    sx={{
      bgcolor: "rgba(25, 118, 210, 0.08)",
      border: "1px solid #93c5fd",
      borderRadius: "8px",
      p: "12px 16px",
      mb: 3,
      cursor: "pointer",
      transition: "all 0.2s ease",
      "&:hover": {
        bgcolor: "rgba(25, 118, 210, 0.12)",
        boxShadow:
          "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)"
      }
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <InfoOutlinedIcon sx={{ color: "#2563eb", flexShrink: 0, fontSize: 20 }} />
        <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e40af" }}>
          Potential Risk is in Beta
        </Typography>
      </Box>
      <ExpandIcon isExpanded={isExpanded} sx={{ color: "#2563eb", fontSize: 18 }} />
    </Box>

    {isExpanded && (
      <Box
        sx={{
          mt: 1.5,
          pt: 1.5,
          borderTop: "1px solid #93c5fd",
          fontSize: "14px",
          color: "#1e3a8a",
          lineHeight: 1.5
        }}
      >
        <Typography sx={{ mb: 1.5, fontSize: "14px", color: "inherit" }}>
          The potential risks generated are generic in nature and are designed to
          highlight possible risks that could be followed up on.
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "inherit" }}>
          {"We're exploring options for customizing risk detection to your specific business needs. "}
          <Link
            href="https://support.spokephone.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#2563eb", fontWeight: 600, textDecoration: "none" }}
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
          >
            Let us know
          </Link>
          {" if this would be valuable for your team."}
        </Typography>
      </Box>
    )}
  </Box>
);

export default BetaBanner;
